import * as globals from '@ahmdigital/constants';
import { flow, intersection, keys } from 'lodash/fp';

// Import constants files and attach them to a files object
import * as agr from '../models/agr/constants';
import * as customer from '../models/customer/constants';
import * as price from '../models/price/constants';
import * as ui from './ui';
import * as url from '../models/url/constants';

const files = { agr, customer, globals, price, ui, url };

// Loop through the imported constant files and check for duplicates,
// as well as extending the constants object to include them.

type ConstantFile = typeof agr | typeof customer | typeof globals | typeof price | typeof ui | typeof url;
type MergedConstants = typeof agr & typeof customer & typeof globals & typeof price & typeof ui & typeof url;

export const cleanConstants = (constantsImports: typeof files): MergedConstants =>
  Object.entries(constantsImports).reduce<Partial<MergedConstants>>((constants, [filename, file]) => {
    const duplicates = flow(keys, intersection(keys(file as ConstantFile)))(constants);
    if (duplicates.length !== 0) {
      throw new Error(
        `Duplicate constant keys found in '${filename}',
      those keys are ambiguous will be overwritten: ${duplicates}`,
      );
    }
    return { ...constants, ...file };
  }, {}) as MergedConstants;

export default cleanConstants(files);
